import { styled } from "@compiled/react";

import { colorCSS, gradientCSS } from "../../../styles";

export const DefaultCard = styled.a({
    "background": colorCSS("N0"),
    "borderRadius": "6px",
    "boxShadow": `0 2px ${colorCSS("N900", 0.25)}`,
    "display": "block",
    "padding": "4px",
    "margin": "0.5rem 0",
    "textDecoration": "none",
    "transition": "transform 0.2s ease",
    "&:hover": {
        transform: "translateY(-5px)"
    },
    "& span": {
        color: colorCSS("N600")
    }
});

export const TeamCard = styled.a({
    "background": gradientCSS("C200", 180),
    "boxShadow": `0 2px ${colorCSS("N100", 0.25)}`,
    "borderRadius": "6px",
    "display": "block",
    "padding": "4px",
    "margin": "0.5rem 0",
    "textDecoration": "none",
    "transition": "transform 0.2s ease",
    "&:hover": {
        transform: "translateY(-5px)"
    },
    "& span": {
        color: colorCSS("N600")
    }
});
